import { buildAppTakeoverConfig } from '../../build-app-takeover-config';
import type { TakeoverRuntimeBindings } from '../../build-app-takeover-config';

import { ConfirmHeaderOverlay } from './components/confirm-header-overlay';
import { HeaderFlair } from './components/header-flair';
import { manifest } from './manifest';

const assets: TakeoverRuntimeBindings<typeof manifest>['assets'] = {
  menuSectionBackground: require('./assets/menu-section-background.png'),
  menuSectionBackgroundHeaderImage: require('./assets/menu-section-background-header-image.png'),
  menuSectionKidsMealsBackground: require('./assets/menu-section-kids-meal-background.png'),
  menuSectionTile: require('./assets/menu-section-tile.png'),
  menuSectionKidsMealsTile: require('./assets/menu-section-kids-meals-tile.png'),
  pdpOverviewTop: require('./assets/pdp-overview-top.png'),
  pdpHeaderFlair: require('./assets/pdp-header-flair.png'),
  pdpHeaderFlairCustomization: require('./assets/pdp-header-flair-customization.png'),
  pdpSummaryBackground: require('./assets/pdp-summary-page-bg.png'),
  mealCartItemBackground: require('./assets/meal-cart-item-background.png'),
  mealCartItem: require('./assets/meal-cart-item.png'),
  kidsCartItemBackground: require('./assets/kids-cart-item-background.png'),
  kidsCartItem: require('./assets/kids-cart-item.png'),
  checkout: require('./assets/checkout.png'),
  orderConfirmHeader: require('./assets/order-confirm-details-header.png'),
  orderConfirmHeaderOverlay: require('./assets/order-confirm-details-header-overlay.png'),
};

const components: TakeoverRuntimeBindings<typeof manifest>['components'] = {
  ConfirmHeaderOverlay,
  HeaderFlair,
};

export const dragonball = buildAppTakeoverConfig(manifest, { assets, components });
